import React from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'
import CustomModal from 'components/CustomModal/CustomModal'
import { API_ROOT } from '../../constants'
import styles from './ConnectionDiagnosticsModal.module.css'

const ConnectionDiagnosticsModal = ({ show, onHide, reachable }) => (
  <CustomModal show={show} onHide={onHide} centered enforceFocus={false}>
    <div className="p-4">
      <Modal.Header closeButton className={styles.header}>
        <Modal.Title className={styles.title}>Trouble logging in?</Modal.Title>
      </Modal.Header>

      <Modal.Body className={styles.body}>
        <Alert variant={reachable ? 'success' : 'danger'} className={styles.result}>
          <Alert.Heading className={styles.resultHeading}>
            {!reachable && (
              <svg className={styles.resultIcon} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path
                  fillRule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.72-1.36 3.486 0l6.518 11.598c.75 1.334-.213 2.986-1.743 2.986H3.482c-1.53 0-2.493-1.652-1.743-2.986L8.257 3.1zM10 7a1 1 0 011 1v3a1 1 0 11-2 0V8a1 1 0 011-1zm0 8a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                  clipRule="evenodd"
                />
              </svg>
            )}
            {reachable ? 'Our servers are reachable' : "We can't reach our servers"}
          </Alert.Heading>
          <p className={styles.resultText}>
            {reachable
              ? "Your network isn't the problem, so it's likely something on this device."
              : 'Something on your network is blocking us.'}
          </p>
        </Alert>

        <p className={styles.intro}>Usually an ISP, antivirus or firewall. Try these:</p>

        <ol className={styles.list}>
          {!reachable && (
            <li>
              <b>Test on mobile data.</b> Turn Wi-Fi off on your phone and log in. If it works, that network is blocking
              us.
            </li>
          )}
          <li>
            <b>Allow us in your antivirus.</b> Add <b>tiiny.host</b> to trusted sites, or disable the antivirus briefly
            as a test.
          </li>
          <li>
            <b>Try another login method.</b> Email link or social login.
          </li>
        </ol>

        <p className={styles.stepText}>
          Still stuck?{' '}
          <span className="link" onClick={() => window.$crisp.push(['do', 'chat:open'])}>
            <u>Contact support</u>
          </span>{' '}
          or email{' '}
          <a href="mailto:support@tiiny.host?subject=Login%20issue">
            <u>support@tiiny.host</u>
          </a>{' '}
          with what you tried.
        </p>

        <a className={styles.checkLink} href={`${API_ROOT}/healthcheck`} target="_blank" rel="noreferrer">
          <u>Check our servers yourself</u>
        </a>
      </Modal.Body>

      <Button className="action-btn w-100 mt-3" onClick={onHide}>
        Got it
      </Button>
    </div>
  </CustomModal>
)

export default ConnectionDiagnosticsModal
